import { gql } from '@apollo/client';

export const HANDLE_PICKUP_FAILED = gql`
  mutation HandlePickupFailed($input: HandlePickupFailedInput!) {
    handlePickupFailed(input: $input)
  }
`;
export interface HandlePickupFailedInput {
  appointmentId: string;
  taskId: string;
  failedReason: string;
  exceptionPhotosS3KeysJson: string[];
  actualPickupDate: string,
  actualPickupTimeEnd: string;
  cooperationWarehouseId?: string;
  /** BOL 提货单图片 S3 密钥，一单一张 */
  bolS3Key?: string;
  /** 揽收备注：司机现场填写，落在 BOL 的 Notes 栏 */
  driverRemark?: string;
  // 揽收失败时刻司机 GPS（动作时刻取位，取不到时留空，不阻断提交）
  latitude?: number;
  longitude?: number;
}
export interface HandlePickupFailedResponse {
  handlePickupFailed: boolean;
}
